import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from "@angular/router";
import { UserService } from "../../services/user/user.service";
import { AppConstants } from 'src/app/constants/app-constants';
import { User } from 'src/app/model/user';

/**
 * HeaderComponent represents the app header
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  /** Whether the user clicked inside the profile section or not */
  private _clickedInside: boolean = false;

  /** The header title */
  headerTitle: string = "";

  /** The user's username */
  name: string = "";

  /** The section of the menu that's open right now */
  menuSection: string = "";

  /**
   * Initalize services and subscribe to router changes 
   * 
   * @param _router 
   * @param _userService 
   * @param _authService 
   */
  constructor(
    private _router: Router, 
    private _userService: UserService, 
  ) {
    // Change the header when the component first loads
    this._setTitle();

    // Subscribe to URL changes and update the header title accordingly
    this._router.events.subscribe(
      (event: any): void => {
        if (event instanceof NavigationEnd) {
          this._setTitle(event);
        }
      });

    // Subscribe to name changes
    this._userService.user$.subscribe(
      (user: User | null): void => {
        this.name = user?.name || "";
      });
  }

  /**
   * When the component initializes get the user's name
   */
  public ngOnInit(): void {
    this.name = this._userService.user?.name || "";
  }

  /**
   * Log the user out using the auth service
   */
  public logout(): void {
    this._userService.logout();

    this._router.navigate([AppConstants.MENU_LOGIN]);
  }

  /**
   * Toggle a menu based on the provided section
   * 
   * @param section
   */
  public toggleMenu(section: string): void {
    // If the section and menu section are the same, close the menu. Otherwise, open the menu
    this.menuSection = section === this.menuSection ? "" : section;
  }

  /**
   * When the profile gets clicked, record it
   */
  clickIn() {
    this._clickedInside = true;
  }

  /**
   * When the document gets clicked and the profile did not, close the menu
   */
  @HostListener('document:click')
  clickOut() {
    // Close the menu if the user clicked outside the profile
    if (!this._clickedInside) {
      this.menuSection = "";
    }
    this._clickedInside = false;
  }

  /**
   * Set the application header based on the router location
   */
  private _setTitle(event?: any): void {
    if (event != undefined) {
      this.headerTitle = event.url.replace('/', '').replace('-', ' ');
    } else {
      this.headerTitle = this._router.url.replace('/', '').replace('-', ' ');
    }
  }

}
